export const theme = {
  baseSpacing: 0.5 //used for CSS spacings
}
